import React from "react";
import "../App.css";

export default function Footer() {
    return (
        <div className="footer">
        <div className="container">
            <div className="divider" />
            <div style={{ paddingTop: 0, fontSize: "16px" }} className="small">
            © 2026 Papp Elíz és Badó Gergely Jószef • Esküvő • Köszönjük, hogy velünk ünnepeltek! 🤍
            </div>
        </div>
        </div>
    );
}
